import { useEffect, useState } from "react";
import { useAxios } from "../../connections/axiosInstance";
import { useAlert } from "../../contexts/alertContext";
import { emptyValidator } from "../../services/validator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { AIRLINES, AIRPORTS } from "./scheduleValue";
import { DateFormat } from "../../services/dateFormat";
import { useFilter } from "../../services/useFilter";

export default function Schedule() {
    const { alertHandler } = useAlert();
    const { isPending, getData, submitData, deleteData, dataFetch } = useAxios({ session: "schedule" });
    const { data: schedules, filterHandler } = useFilter(dataFetch);
    const [newSchedule, setNewSchedule] = useState({
        departure: {},
        arival: {},
        airline: {},
        time: {},
    });
    
    // schedule status
    const Status = ({scheduleTime}) => {
        let time = new Date(scheduleTime).getTime() > new Date().getTime()
        return (
            <span style={{ background: time ? "var(--yellow-light)" : "var(--green-light)"}} className="p-1 text-xs font-semibold">
                {time ? "On Schedule" : "Success"}
            </span>
        )
    }

    useEffect(() => {
        // get schedule data
        getData("/schedule");
        //eslint-disable-next-line
    }, []); 

    async function submitHandler() {
        // submit new schedule
        const errors = emptyValidator(newSchedule);
        if (errors.length > 0) {
            return alertHandler({ status: 2, message: "Please fill all field" });
        }
        submitData("/schedule", newSchedule);
    }

    async function deleteHandler(id) {
        // delete schedule
        if (id) deleteData(`/schedule/${id}`, id);
    }

    return (
        <section className="w-full">
            <section className="bg-white rounded-lg shadow p-3.5 h-max mb-5 md:w-1/4 w-full">
                <h1 className="font-bold mb-3.5">CREATE SCHEDULE</h1>
                <table className="w-full">
                    <tbody>
                        <tr>
                            <td>From</td>
                            <td>
                                <select
                                    name="departure"
                                    className=" bg-transparent w-full text-right optional:bg-white uppercase"
                                    onChange={(event) =>
                                        setNewSchedule((prev) => ({
                                            ...prev,
                                            departure: AIRPORTS[event.target.value],
                                        }))
                                    }
                                >
                                    <option value="">SELECT DEPARTURE</option>
                                    {AIRPORTS.map((departure, index) => (
                                        <option
                                            value={index}
                                            key={index}
                                            disabled={departure.airport === newSchedule.arival.airport}
                                            style={{
                                                color:
                                                    departure.airport === newSchedule.arival.airport &&
                                                    "var(--gray)",
                                            }}
                                        >
                                            {departure.airport} - {departure.country}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>To</td>
                            <td>
                                <select
                                    name="arival"
                                    className=" bg-transparent w-full text-right optional:bg-white uppercase"
                                    onChange={(event) =>
                                        setNewSchedule((prev) => ({
                                            ...prev,
                                            arival: AIRPORTS[event.target.value],
                                        }))
                                    }
                                >
                                    <option value=""> SELECT ARIVAL </option>
                                    {AIRPORTS.map((arival, index) => (
                                        <option
                                            value={index}
                                            key={index}
                                            disabled={arival.airport === newSchedule.departure.airport}
                                            style={{
                                                color:
                                                    arival.airport === newSchedule.departure.airport &&
                                                    "var(--gray)",
                                            }}
                                        >
                                            {arival.airport} - {arival.country}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>Airline</td>
                            <td>
                                <select
                                    name="airline"
                                    className=" bg-transparent w-full text-right optional:bg-white uppercase"
                                    onChange={(event) =>
                                        setNewSchedule((prev) => ({
                                            ...prev,
                                            airline: AIRLINES[event.target.value],
                                        }))
                                    }
                                >
                                    <option value=""> SELECT AIRLINE</option>
                                    {AIRLINES.map((airport, index) => (
                                        <option value={index} key={index}>
                                            {airport.name}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>Time</td>
                            <td>
                                <input
                                    type="date"
                                    className="w-full"
                                    onChange={(event) =>
                                        setNewSchedule((prev) => ({ ...prev, time: event.target.value }))
                                    }
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button
                    className="w-full p-2 mt-5 rounded-lg"
                    onClick={submitHandler}
                    style={{
                        background: isPending ? "var(--gray-light)" : "var(--blue)",
                        color: isPending ? "" : "var(--white)",
                    }}
                >
                    {isPending ? (
                        <FontAwesomeIcon icon={faSpinner} className="spinning" />
                    ) : (
                        <span>SUBMIT</span>
                    )}
                </button>
            </section>
            <section className="border-b-2 my-5 md:w-2/4 md:flex gap-2 max-[768px]:px-2 schedule-filter">
                <div>
                    <label htmlFor="filter">Departure: </label>
                    <select className="p-2 h-full px-2 bg-[--gray-light]" id="departure" onChange={(event) => filterHandler(event)}>
                        <option value="">All</option>
                        <option value="jepang">Jepang</option>
                        <option value="indonesia">Indonesia</option>
                    </select>
                </div>
                <div>
                    <label htmlFor="month">Month: </label>
                    <input
                        type="number"
                        min={1}
                        max={12}
                        id="month"
                        className="h-full p-2 bg-[--gray-light]"
                        onChange={(event) => filterHandler(event)}
                    />
                </div>
                <div>
                    <label htmlFor="month">Year: </label>
                    <input
                        type="number"
                        min={2024}
                        max={2030}
                        id="year"
                        className="h-full p-2 bg-[--gray-light]"
                        onChange={(event) => filterHandler(event)}
                    />
                </div>
            </section>
            <section className="rounded-lg border-2 h-[500px] my-5 md:m-0 md:w-2/4 overflow-y-scroll  max-[768px]:px-2 bg-white">
                <table className="w-full text-left uppercase schedule h-max overflow-scroll ">
                    <thead className="sticky top-0 text-center">
                        <tr>
                            <th>from</th>
                            <th>to</th>
                            <th>airline</th>
                            <th>date</th>
                            <th>status</th>
                            <th>action</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {!isPending ? (
                            schedules?.map((schedule) => (
                                <tr key={schedule._id} className="font-semibold">
                                    <td>{schedule.departure.airport}</td>
                                    <td>{schedule.arival.airport}</td>
                                    <td className="capitalize">{schedule.airline.name}</td>
                                    <td className="text-right">{new DateFormat(schedule.time).display()}</td>
                                    <td className="text-right"><Status scheduleTime={schedule.time}/></td>
                                    <td>
                                        <button
                                            className="underline text-[var(--blue)] w-full text-center"
                                            onClick={() => deleteHandler(schedule._id)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr className="h-full w-full flex justify-center items-center"></tr>
                        )}
                    </tbody>
                </table>
            </section>
        </section>
    );
}
